import { styled } from '@innowise-group/mui-kit';

export const Container = styled.div`
  white-space: pre-wrap;
  padding: 15px;
  overflow-y: auto;
  overflow-x: hidden;
`;
